import { render, staticRenderFns } from "./ClientesCob.vue?vue&type=template&id=6d9c5015&scoped=true&"
import script from "./ClientesCob.vue?vue&type=script&lang=js&"
export * from "./ClientesCob.vue?vue&type=script&lang=js&"
import style0 from "./ClientesCob.vue?vue&type=style&index=0&id=6d9c5015&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c5015",
  null
  
)

export default component.exports